export const REDEEM_TYPE_DEFAULT = 'DEFAULT';
export const REDEEM_TYPE_LOGIN_ONLY = 'LOGIN_ONLY';
export const REDEEM_TYPE_GUEST_ONLY = 'GUEST_ONLY';

export const DEFAULT_LANGUAGE = 'de';
